<template>
  <div class="tasks-item" :class="getPriorityClass(item)">
    <div class="tasks-item__checkbox" @click="dialogTaskCompliteVisible = true">
      <el-icon v-if="item.status === 'completed'">
        <component :is="'SuccessFilled'" />
      </el-icon>
    </div>
    <div class="tasks-item-info" @click="showTask(item)">
      <div class="title-wraper">
        <p class="tasks-item__name">{{ item.title }}</p>
        <div class="tasks-item__completed">{{ item.status == 'completed' ? `Completed: ${timeConverter(item.update)}` : '' }}</div>
      </div>
      <el-tag size="mini" type="warning">
        {{ `${item.zone}` }}
      </el-tag>
      <el-tag size="mini">
        {{ `${item.location.name}` }}
      </el-tag>
      <el-tag size="mini">
        {{ `${item.location.address}` }}
      </el-tag>
      <el-tag size="mini">
        {{ `Time offline: ${calculateTimeToNow(item.changed)}` }}
      </el-tag>
      <div v-if="item.manualCode" class="tasks-item__station">
        ManualCode: {{ item.manualCode }}
      </div>
    </div>

    <div class="tasks-item-actions">
      <div class="tasks-item-rate" @click="setFavorute(item)">
        <el-icon>
          <component :is="item.isFavorite === '1' ? 'StarFilled' : 'Star'" />
        </el-icon>
      </div>
      <div
        v-if="item.phone"
        class="tasks-item-call"
        @click.stop="callPhone(item)"
      >
        <el-icon>
          <component :is="'Phone'" />
        </el-icon>
      </div>
    </div>
  </div>

  <el-dialog :title="task.title" v-model="isShowTask" :fullscreen="isMobile">
    <p>{{ task.text }}</p>
    <el-divider></el-divider>

    <el-descriptions>
      <el-descriptions-item label="Deadline">
        <el-tag size="small">{{ task.mustDone }}</el-tag>
      </el-descriptions-item>
      <el-descriptions-item label="Group">
        <el-select
          v-model="task.groupId"
          placeholder="Choose group"
          @change="setGroup()"
        >
          <el-option
            v-for="item in groupList"
            :key="item.id"
            :label="item.title"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-descriptions-item>
    </el-descriptions>

    <el-tag size="mini">
      {{ `${task.location.name} ${task.location.address}` }}
    </el-tag>
    <el-divider></el-divider>

    <el-descriptions title="Comments">
      <el-descriptions-item>
        <el-timeline :reverse="reverse">
          <el-timeline-item
            v-for="(item, key) in task.comments"
            :key="key"
            :timestamp="item.comments"
          >
            {{ item.userName }}
          </el-timeline-item>
        </el-timeline>
      </el-descriptions-item>
    </el-descriptions>
    <CommentCreate :taskId="task.id" @createdComment="createdComment" />
  </el-dialog>


  <el-dialog v-model="dialogTaskCompliteVisible" title="Task complete">
    <el-form :model="form">
      <el-descriptions title="Add comment">
        <!-- <el-descriptions-item>
          <el-timeline :reverse="reverse">
            <el-timeline-item
              v-for="(item, key) in task.comments"
              :key="key"
              :timestamp="item.text"
            >
              {{ item.userName }}
            </el-timeline-item>
          </el-timeline>
        </el-descriptions-item> -->
      </el-descriptions>
      <CompleteTaskCommentCreate :taskId="item.id" @completeTaskCommentCreate="completeTaskCommentCreateMethod" />
    </el-form>
  </el-dialog>
</template>

<script>
import ApiTask from "@/api/task";
import ApiGroup from "@/api/group";
import bus from "vue3-eventbus";
import CommentCreate from "@/components/Task/CommentCreate";
import CompleteTaskCommentCreate from "@/components/Task/CompleteTaskCommentCreate";
import { mapGetters } from "vuex";
import _ from "lodash";
import prettyMs from 'pretty-ms'

import moment from "moment";
export default {
  props: {
    item: {
      default: () => {},
      type: Object,
    },
  },
  data() {
    return {
      task: {},
      isShowTask: false,
      isMobile: false,
      dialogTaskCompliteVisible: false,
    };
  },
  components: {
    CommentCreate,
    CompleteTaskCommentCreate
  },
  computed: {
    ...mapGetters("User", ["user", "groupList", "zoneList"]),
  },
  methods: {
  calculateTimeToNow(timestamp) {
    return prettyMs(new Date() - timestamp * 1000, {
      secondsDecimalDigits: 0,
      millisecondsDecimalDigits: 0,
    })
  },
  timeConverter(UNIX_timestamp){
  var a = new Date(UNIX_timestamp * 1000);
  var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var year = a.getFullYear();
  var month = months[a.getMonth()];
  var date = a.getDate();
  var hour = a.getHours();
  var min = a.getMinutes();
  var sec = a.getSeconds();
  var time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec ;
  return time;
},
  getPriorityClass(item) {
    switch (true) {
      case (item.priority1 == "1" || item.priority2 == "1" ):
        return "hight";
        break;
      case (item.priority3 == "1" || item.priority4 == "1" || item.priority5 == "1" ):
        return "medium";
        break;
      case (item.priority6 == "1" || item.priority7 == "1" ):
        return "default";
        break;

      default:
        break;
    }
  },

    // getPriorityClass(item) {
    //   switch (item.priority) {
    //     case "A":
    //       return "hight";
    //       break;
    //     case "B":
    //       return "medium";
    //       break;
    //     case "C":
    //       return "default";
    //       break;
    //     case "L":
    //       return "default";
    //       break;

    //     default:
    //       break;
    //   }
    // },
    showTask(item) {
      this.task = JSON.parse(JSON.stringify(item));
      this.task.groupId = _.find(
        this.groupList,
        (item) => Number(this.task.groupId) == item.id
      );
      console.log(moment(item.mustDone));
      this.task.mustDone = moment(item.mustDone).format("YYYY-MM-DD");
      this.isShowTask = true;
    },
    setGroup(item) {
      ApiGroup.setGroup({
        taskId: this.task.id,
        groupId: this.task.groupId,
      }).then((responce) => {
        bus.emit("compliteTask", Number(this.task.id));
        if (responce.status) {
          this.$message({
            message: "Group was set",
            type: "success",
          });
        } else {
          this.$message({
            message: "Something wrong",
            type: "danger",
          });
        }
      });
    },
    completeTaskCommentCreateMethod(item, elemId) {
      if (this.item.id == elemId) {
        console.log('item', this.item)
        console.log('elem', Number(elemId))
        this.dialogTaskCompliteVisible = false;

        this.item.status == "completed" ? ApiTask.activate(elemId) : ApiTask.compliteWithUser(elemId);
        setTimeout(() => {
          bus.emit("compliteTask", Number(elemId));
        }, 500);

        if (this.task.comments) {
          this.task.comments.push({
            userName: this.user.name,
            text: item.text,
          });
        }
      }
    },
    compliteTask(elem) {
      ApiTask.complite(elem.id);
      bus.emit("compliteTask", Number(elem.id));
    },
    callPhone(elem) {
      window.location.href = `tel:${elem.phone}`;
    },
    setFavorute(elem) {
      ApiTask.setFavorute({
        taskId: elem.id,
        isFavorite: elem.isFavorite === "1" ? 0 : 1,
      });
      setTimeout(() => {
        bus.emit("compliteTask", Number(elem.id));
      }, 500);
    },
    createdComment(item) {
      if (this.task.comments) {
        this.task.comments.push({
          userName: this.user.name,
          text: item.text,
        });
      }

      setTimeout(() => {
        bus.emit("compliteTask", Number(this.task.id));
      }, 500);
    },
  },
  mounted() {
    if (window.innerWidth <= 768) {
      this.isMobile = true;
    }
  },
};
</script>